// extracted by mini-css-extract-plugin
module.exports = {"investorAnnouncement":"InvestorAnnouncements_investorAnnouncement__UrdQ3","ctaButton":"InvestorAnnouncements_ctaButton__fx2nO"};